var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuiz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0068 2C13.6245 2 15.2361 2.39907 16.668 3.15403C21.5432 5.72638 23.4181 11.7855 20.8475 16.6624C19.0942 19.9879 15.642 22 11.9953 22C11.2829 22 10.5634 21.9234 9.84742 21.7648C8.70198 21.5111 7.32539 20.7838 6.56759 20.2098L6.51154 20.2302L6.47742 20.2426C5.73917 20.5101 4.74509 20.8703 4.0704 21.0213C4.01228 21.0336 3.94975 21.0415 3.89251 21.0398C3.43282 21.0398 3.15277 20.8539 2.99866 20.6971C2.76177 20.4566 2.64905 20.1192 2.66225 19.6946C2.66402 19.6461 2.67018 19.5959 2.68163 19.5475C2.85952 18.7899 3.09113 18.034 3.37117 17.3019C3.39143 17.2306 3.3791 17.1011 3.32186 16.9927L3.129 16.6183C2.39014 15.2035 1.99825 13.6029 2.00001 11.9978C2.00001 6.48487 6.48424 2 11.9953 2H12.0068Z",
    fill: "#FF845E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59316 10.8101C6.93709 10.8101 6.4043 11.343 6.4043 11.9993C6.4043 12.6547 6.93709 13.1877 7.59316 13.1877C8.24924 13.1877 8.78203 12.6547 8.78203 11.9993C8.78203 11.343 8.24924 10.8101 7.59316 10.8101Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1844 11.9993C13.1844 11.3439 12.6516 10.8101 11.9955 10.8101C11.3394 10.8101 10.8066 11.3439 10.8066 11.9993C10.8066 12.6547 11.3394 13.1886 11.9955 13.1886C12.6516 13.1886 13.1844 12.6547 13.1844 11.9993Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5867 11.9993C17.5867 11.3439 17.0539 10.8101 16.3979 10.8101C15.7418 10.8101 15.209 11.3439 15.209 11.9993C15.209 12.6547 15.7418 13.1886 16.3979 13.1886C17.0539 13.1886 17.5867 12.6547 17.5867 11.9993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.a8d5c81f068d171739235bc63760b2de.svg";
export { ForwardRef as ReactComponent };